import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';

import imagesList from '@/constant/images-list';

type Props = {
  saleAmount: number;
  successfulSale: string;
};

export default function SalesInfo({ saleAmount, successfulSale }: Props) {
  return (
    <Container className='flex w-fit items-center md:w-full md:justify-between md:gap-12'>
      <Container className='flex flex-col items-center justify-center md:items-start'>
        <Text className='text-[33px] font-bold leading-6 text-[#1F2025] lg:text-[40px]'>
          {saleAmount}
        </Text>
        <Text className='whitespace-nowrap text-[13px] font-light leading-8 tracking-tighter text-[#76767C] lg:text-[15px]'>
          {successfulSale}
        </Text>
      </Container>
      <XImage
        alt='guarantee'
        width={70}
        height={60}
        src={imagesList.icons.guarantee}
        className='hidden md:flex'
      />
    </Container>
  );
}
